module.exports = __webpack_public_path__ + "img/footer_logo.8f08596f.svg";